import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Home, TrendingUp, Award } from 'lucide-react';
const audiences = [{
  icon: Sparkles,
  title: 'Personas sin experiencia en carpintería',
  description: 'Principiantes absolutos que nunca fabricaron un mueble y quieren empezar este fin de semana.',
  isNew: false
}, {
  icon: Home,
  title: 'Tenés cualquier espacio disponible',
  description: 'Con un balcón, lavadero o cochera te alcanza. Sin taller profesional, sin equipamiento caro.',
  isNew: false
}, {
  icon: TrendingUp,
  title: 'Fabricantes que quieren convertirlo en negocio',
  description: 'Querés transformar la habilidad en ingresos reales de hasta $3000 USD por mes.',
  isNew: true
}, {
  icon: Award,
  title: 'Buscás muebles que se vendan premium',
  description: 'Vas por el escritorio Japandi, la cama plataforma, el rack de TV o la mesa ratona que vale $85.000.',
  isNew: false
}];
export function TargetAudience() {
  return <section className="py-8 md:py-16 px-4 bg-white" data-id="element-257">
      <div className="max-w-7xl mx-auto" data-id="element-258">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-5xl font-bold text-center mb-2 md:mb-4" data-id="element-259">
          ¿PARA QUIÉN ES?
        </motion.h2>

        <p className="text-center text-sm md:text-lg mb-6 md:mb-12 text-[#2B2724]/80" data-id="element-260">
          Diseñado para vos si querés fabricar y vender muebles Japandi en
          Argentina
        </p>

        <div className="flex flex-col gap-3 md:gap-4 mb-6 md:mb-8" data-id="element-261">
          {audiences.map((audience, index) => {
          const Icon = audience.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} whileTap={{
            scale: 0.98
          }} className="flex items-center gap-3 md:gap-4 bg-[#F5F0E8] p-3 md:p-4 rounded-lg border border-[#2B2724]/10 relative" data-id="element-262">
                <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#C2613A]/10" data-id="element-263">
                  <Icon className="w-5 h-5 md:w-6 md:h-6 text-[#C2613A]" data-id="element-264" />
                </div>
                <div className="flex-1 min-w-0 pr-14 md:pr-16" data-id="element-265">
                  <h3 className="font-bold text-xs md:text-base mb-0.5" data-id="element-266">
                    {audience.title}
                  </h3>
                  <p className="text-[10px] md:text-sm text-[#2B2724]/70 leading-relaxed" data-id="element-267">
                    {audience.description}
                  </p>
                </div>
                {audience.isNew && <span className="absolute top-3 right-3 md:top-4 md:right-4 bg-[#C2613A] text-white text-[10px] md:text-xs px-2 py-0.5 md:px-3 md:py-1 rounded-full font-semibold" data-id="element-268">
                    NUEVO
                  </span>}
              </motion.div>;
        })}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-sm" data-id="element-269">
          ¿No estás seguro si es para vos?{' '}
          <a href="#guarantee" className="text-[#C2613A] font-semibold hover:underline" data-id="element-270">
            Tenés 7 días de garantía →
          </a>
        </motion.p>
      </div>
    </section>;
}